import { WizardContext } from '../wizardMachine'

export const hasNoBookableSlot = (context: WizardContext): boolean => {
  const { slots } = context
  return !slots?.length
}
